<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="type" class="card-time-wrap">
    <div v-tooltip="translationTime" class="icon-wrapper">
      <div :class="type + '-icon'" />
    </div>
  </div>
</template>

<script>
import { t } from '@/i18n'
/**
 * Display diferent icon logo depending on type
 */
export default {
  name: 'ItemTimeIcon',
  props: {
    /**
     * Sets the type of the icon
     * @values dia, mes, trimestre, any
     */
    types: {
      type: String,
    },
  },
  computed: {
    type() {
      // debugger
      // if (this.types && this.types.length > 1) return 'multiple'
      // else {
        if ( !this.types ) return undefined
        else if (this.types.toLowerCase() === 'dia') return 'day'
        else if (this.types.toLowerCase() === 'setmana') return 'week'
        else if (this.types.toLowerCase() === 'mes') return 'month'
        else if (this.types.toLowerCase() === 'trimestre') return 'trim'
        else if (this.types.toLowerCase() === 'any') return 'year'
        else return undefined
      // }
    },
    translationTime() {
      // let count = this.types.length
      let transString = t(this.types.toLowerCase())
      // if (this.types && count > 1) {
      //   this.types.forEach((element, i) => {
      //     if (i === 0) transString = t(element)
      //     else if (i < count - 1) transString += ', ' + t(element)
      //     else transString += ' ' + t('and') + ' ' + t(element)
      //   })
      // } else {
      //   transString = this.types && this.types[0] ? t(this.types[0]) : ''
      // }
      return transString
    },
  },
}
</script>

<style lang="stylus" scoped>
.card-time-wrap
  display: flex
  margin-left: vw(10px)
  padding-left: vw(10px)
  border-left: 1px solid $bcn-other-grey

  .icon-wrapper
    display: flex
    align-items: center
    $icons = "day" "week" "month" "trim" "year"

    for $icon in $icons
      .{$icon}-icon
        m-icon("tm-" + $icon, 28, $corporate_color, false)
</style>